import { Box } from '@chakra-ui/react'
import { useMaintenanceDisclosure } from '@/lib/hooks/useMaintenanceDisclosure'
import { MaintenanceModal } from '@/components/MaintenanceModal/MaintenanceModal'
import { ResponsiveCSSObject } from '@/styles/types'

type Props = {
  href: string
  children: React.ReactNode
  openInNewTab?: boolean
  onClick?: () => void
  as?: any
  sx?: ResponsiveCSSObject
}

export const GuardedExternalLink = ({
  href,
  children,
  openInNewTab = true,
  onClick,
  as,
  sx,
}: Props) => {
  const disclosure = useMaintenanceDisclosure()
  const isUnderMaintenance =
    process.env.NEXT_PUBLIC_IS_UNDER_MAINTENANCE === 'true'

  const handleClick = (
    e: React.MouseEvent<HTMLElement | HTMLAnchorElement>,
  ) => {
    e.preventDefault()
    e.stopPropagation()
    onClick?.()
    if (isUnderMaintenance) {
      disclosure.onOpen()
    } else {
      if (openInNewTab) {
        window.open(href, '_blank', 'noopener,noreferrer')
      } else {
        window.location.href = href
      }
    }
  }

  const Tag = as || 'button'

  return (
    <>
      <Box
        as={Tag}
        onClick={handleClick}
        role="link"
        tabIndex={0}
        sx={{ cursor: 'pointer', ...sx }}
      >
        {children}
      </Box>
      <MaintenanceModal
        isOpen={disclosure.isOpen}
        onClose={disclosure.onClose}
      />
    </>
  )
}
